import styled from 'styled-components';
import {
  tablet_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const SubHeaderStyles = styled.div`
  font-family: 'source-sans-pro', sans-serif;
  margin: 0 auto 50px;
  max-width: calc(100% - 30px);

  span {
    font-family: 'source-sans-pro', sans-serif;
  }
  a {
    align-items: center;
    border-bottom: 1px solid ${Colors.accent.grey5.standard};
    color: ${Colors.primary.black.standard} !important;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    padding: 10px 15px;
    text-align: left;
    text-transform: uppercase;
    width: 100%;
    text-decoration: none;

    &:last-child {
      border: none;
    }

    &:hover,
    &:visited {
      text-decoration: none;
    }
    span {
      display: inline-block;
      margin-left: 25px;
    }
    svg {
      width: 25px;
      height: 25px;
    }
  }

  @media only screen and (min-width: ${tablet_breakpoint}px) {
    max-width: 480px;
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    max-width: 900px;

    a {
      border-bottom: none;
      border-right: 1px solid ${Colors.accent.grey5.standard};
      display: inline-block;
      margin: 15px 0;
      width: 33%;
      text-decoration: none;

      &:last-child {
        border: none;
      }
      span,
      svg {
        display: block;
        margin: 0 auto 5px;
        text-align: center;
      }
    }
  }
`;

export default SubHeaderStyles;
